<template>
    <section class="content showcases">
        <div class="pad">
            <div class="wrap">
                <div class="showcases-head">
                    <div class="form grey-fields">
                        <div class="search">
                            <input type="text" :placeholder="data.placeholder" v-model="query" @keyup="debounceSearch(true)">
                        </div>
                        <select class="large" v-model="selectedFormat" @click="clickSelectFormat" @change="formatSelected()">
                            <option :value="null">{{ window.t('showcase_selectbox') }}</option>
                            <option v-for="(format, formatIndex) in data.availableFormats" :value="format.slug" :key="'format-'+formatIndex">{{ format.format }}</option>
                        </select>
                    </div>
                </div>
                <div class="showcases-body">
                    <div class="items">
                        <a v-for="showcase in showcases" :key="showcase.id" class="item" :href="showcase.url" @click="clickShowcase(showcase)">
                            <div class="item-inner">
                                <div class="image-box">
                                    <div class="bg-box">
                                        <div class="bg" :style="showcaseBackgroundStyle(showcase)"></div>
                                    </div>
                                    <div class="mask"></div>
                                </div>
                                <h2 class="h2">{{ showcase.name }}</h2>
                                <div class="txt">
                                    {{ showcase.format }}
                                </div>
                                <span class="btn">Listen now</span>
                            </div>
                        </a>
                        <div ref="lazy-load-trigger" class="lazy-load-trigger"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        props: {
            data: {
                type: Object,
                default: () => ({})
            },
            defaultLanguage: {
                type: String,
                default: 'en',
            },
            language: {
                type: String,
                default: 'en',
            },
            basePath: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                window,
                query: '',
                perPage: 6,
                showcases: [],
                debounceSearch:  _.debounce(this.fetchData, 400, {reset: true, searchTriggered: true}),
                lazyLoadObserver: null,
                stopLoading: false,
                watchRoute: true,
                selectedFormat: null,
                searchEventTriggered: false,
            };
        },
        mounted() {
            this.lazyLoadObserver = new IntersectionObserver(this.lazyLoad);
            this.lazyLoadObserver.observe(this.$refs['lazy-load-trigger']);

            let formatSlug = this.formatSlugPath()
            if (this.data.availableFormats.filter(format => format.slug == formatSlug).length) {
                this.selectedFormat = formatSlug;
            }
        },
        methods: {
            clickSelectFormat() {
                _gte('click', {
                    'event_category': 'Showcase',
                    'event_label':  window.t('showcase_selectbox')
                });
            },
            clickShowcase(showcase) {
                _gte('click', {
                    'event_category': 'Showcase',
                    'event_label':  showcase.name
                });
            },
            goToPath: async function (fetchData = true) {
                this.watchRoute = false;

                let goToPath = '/' + this.basePath;

                if (this.selectedFormat) {
                    goToPath += '/' + this.selectedFormat;
                }

                if (goToPath != this.$route.path) {
                    await router.push(goToPath);

                    if (fetchData) {
                        this.fetchData(1);
                    }
                }
                this.watchRoute = true;
            },
            showcaseBackgroundStyle(showcase) {
                var style = '';

                if (showcase.image) {
                    style = 'background-image:url(\'/files/' + showcase.image + '\');';
                } else if (showcase.logo) {
                    style = 'background-color:' + showcase.color + '; background-image:url(\'/files/' + showcase.logo + '\'); background-size:200px auto; background-repeat:no-repeat;';
                } else {
                    style = 'background-color:' + showcase.color;
                }

                return style;
            },
            formatSelected(){
                _gte('click_format', {
                    'event_category': 'Showcase',
                    'event_label':  this.selectedFormat
                });
                this.goToPath();
            },
            fetchData(reset = false, searchTriggered = false) {
                let formatSlug = this.formatSlugPath();

                let skip = 0;

                for (let showcase of this.showcases) {
                    if (!showcase.featured) {
                        skip++;
                    }
                }

                if (reset) {
                    this.stopLoading = false;
                    skip = 0;

                    if (!this.searchEventTriggered) {
                        this.searchEventTriggered = true;
                    }
                }

                if (searchTriggered) {
                    _gte('search', {
                        'event_category': 'Showcase',
                        'event_label': this.query
                    });
                }

                if (this.stopLoading) {
                    return;
                }

                axios.post((this.language != this.defaultLanguage ? '/' + this.language : '') + '/showcases/data', {
                    q: this.query,
                    formatSlug: formatSlug,
                    perPage: this.perPage,
                    skip
                })
                .then(response => {
                    if (response.data.hasOwnProperty('showcases')) {
                        if (reset) {
                            this.showcases = response.data.showcases;
                        } else {
                            this.showcases = [...this.showcases, ...response.data.showcases];
                        }
                    }

                    if (response.data.showcases.length < this.perPage) {
                        this.stopLoading = true;
                    }
                });
            },
            formatSlugPath() {
                let formatSlugPath = this.$route.path.replace(/^\/|\/$/g, '');

                if (this.basePath) {
                    formatSlugPath = formatSlugPath.replace(this.basePath, '').replace(/^\/|\/$/g, '');
                }
                return formatSlugPath;
            },
            lazyLoad(entries) {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                       this.fetchData();
                    }
                });
            }
        },
        watch: {
            '$route' (to, from) {
				if (to.path != from.path && this.watchRoute && this.initialized) {
                    this.initialized = false;
					this.fetchData(1);
				}
			},
        }
    }
</script>
